<template>
  <div class="fundManageDetail">
    <!-- 标题 -->
    <div class="titleBox flex-row ite-c">
      <b>{{topTitle.title}}</b>
      <span v-show="topTitle.subTit!==''">-{{topTitle.subTit}}</span>
      <span v-show="topTitle.thirdTit!==''">-{{topTitle.thirdTit}}</span>
    </div>

    <!-- 筛选框 -->
    <sr-filter class="searchBox" @search="handleSearch" @reset="handleReset">
      <template slot="otherCom">

        <el-form-item>
          <el-input
                  v-model="searchForm.params.account"
                  placeholder="输入会员账号"
                  @keyup.enter.native="handleSearch"
                  maxlength="25" size="medium" clearable
          >
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-input
                  v-model="searchForm.params.memberName"
                  placeholder="输入会员名称"
                  @keyup.enter.native="handleSearch"
                  maxlength="25" size="medium" clearable
          >
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-select v-model="searchForm.params.memberType"
                     placeholder="请选择会员类型"
                     @change="handleSearch"
                     size="medium"
                     clearable
                     filterable>
            <el-option v-for="item in memberTypeOptions" :key="item.key" :label="item.label"
                       :value="item.key"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item>
          <el-date-picker
                  v-model="timeRange"
                  type="datetimerange"
                  unlink-panels
                  size="medium"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  :default-time="['00:00:00', '23:59:59']"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="timePickerOptions"
          >
          </el-date-picker>
        </el-form-item>

      </template>
    </sr-filter>

    <!-- 表格 -->
    <div class="botTable boxs tableTheadGray">

      <div class="tableTop flex_h_hS_vC boxs">
        <!-- tab切换-类型切换 -->
        <ul class="tabBox clearfix">
          <li v-for="(item,index) in tabData.textArr"
              @click="tabLi(index)"
              :class="{on:tabData.nowIndex==index}">{{item}}
          </li>
        </ul>
        <!-- 导出按钮 -->
        <span class="top_ri">
              <button class="butStyle pinkBtn exportBtn" @click="tableExport">
                  <i class="exportIcon"></i>
                  <span>导出</span>
              </button>
          </span>
      </div>

      <el-table :data="tableData"
                style="width: 100%;"
                border
                fit
                highlight-current-row
                tooltip-effect="dark"
      >
        <el-table-column label="时间" prop="logTime" min-width="160" header-align="center" align="center"
                         show-overflow-tooltip></el-table-column>
        <el-table-column label="金额（元）" prop="fee" min-width="120" header-align="center" align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="orangeT">{{scope.row.fee | centsToYuan}}</span>
          </template>
        </el-table-column>
        <el-table-column label="手续费（元）" prop="" min-width="120" header-align="center" align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="orangeT">{{scope.row.handlingFee | centsToYuan}}</span>
          </template>
        </el-table-column>
        <el-table-column label="类型" prop="tradeType" min-width="120" header-align="center" align="center"
                         show-overflow-tooltip></el-table-column>
        <el-table-column label="会员类型" prop="memberType" min-width="120" header-align="center" align="center"
                         show-overflow-tooltip></el-table-column>
        <el-table-column label="会员名称" prop="memberName" min-width="130" header-align="center" align="center"
                         show-overflow-tooltip></el-table-column>
        <el-table-column label="会员账号" prop="account" min-width="170" header-align="center" align="center"
                         show-overflow-tooltip></el-table-column>
      </el-table>
      <div class="pageBox boxs">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="searchForm.current" :page-sizes="[10, 20, 30]" :page-size="searchForm.size"
                       layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
  import SrFilter from '@/components/Common/Filter/Filter'
  import {formatDate} from '@/utils/dateFormatter';
  import {objectToQueryString} from '@/utils/commonUtils.js';
  import {
    getFundDetailListAPI, // 资金明细-获取资金明细列表
  } from '@/api/Finance/fundManage.js';

  // 搜索表格的条件
  const searchConst = {
    current: 1, //当前页码
    size: 10, //每页条数
    params: {
      account: null, //输入会员账号
      memberName: null, //输入会员名称
      memberType: -1, //选择会员类型
      minDateTime: null,
      maxDateTime: null,
      queryType: 1
    }
  }

  export default {
    name: "fundManageDetail",
    data() {
      return {
        timeRange: null,
        //标题
        topTitle: {
          title: '资金管理',
          subTit: '资金明细',
          thirdTit: '',
        },

        // 会员类型
        memberTypeOptions: [
          {key: -1, label: '全部'},
          {key: 0, label: '代理商会员'},
          {key: 1, label: '网点会员'},
          {key: 2, label: '微店会员'},
          {key: 3, label: '超级会员'},
          {key: 4, label: '平台商/运营商会员'},
          {key: 5, label: '顾客会员'},
        ],
        // 资金类型切换
        tabData: {
          textArr: ['支出资金', '收入资金', '冻结资金', '解冻资金'],
          nowIndex: 0
        },
        // 表格搜索条件
        searchForm: this.$deepClone(searchConst),
        // 表格数据
        tableData: [],
        // 表格数据总数
        total: 0,


        // 日期时间选择器
        timePickerOptions: {
          disabledDate(time) {
            // return time.getTime() > Date.now();
          },
          shortcuts: [
            {
              text: '今天',
              onClick(picker) {
                // picker.$emit('pick', [new Date(), new Date()])
                const end = new Date()
                const start = new Date()
                start.setHours('00', '00', '00')
                end.setHours('23', '59', '59')
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '昨天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24)
                start.setHours('00', '00', '00')
                end.setHours('23', '59', '59')
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 3)
                start.setHours('00', '00', '00')
                end.setHours('23', '59', '59')
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                start.setHours('00', '00', '00')
                end.setHours('23', '59', '59')
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                start.setHours('00', '00', '00')
                end.setHours('23', '59', '59')
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                start.setHours('00', '00', '00')
                end.setHours('23', '59', '59')
                picker.$emit('pick', [start, end]);
              }
            }
          ]
        }
      }
    },
    computed: {
      min_accept_time() {
        return this.timeRange ? this.timeRange[0] : null
      },
      max_accept_time() {
        return this.timeRange ? this.timeRange[1] : null
      }
    },
    components: {
      SrFilter
    },
    created() {
      this.getDataList()
    },
    methods: {
      // 导出
      tableExport() {
        this.searchForm.params.minDateTime = this.min_accept_time
        this.searchForm.params.maxDateTime = this.max_accept_time
        const url = `${this.$baseNewUrl}esaleb-service-funds/pt-funds/log/export?accessToken=${this.$accessToken()}&${objectToQueryString(this.searchForm.params)}`;
        window.open(url, '_blank');
      },

      formatDefault: function (date) {
        return formatDate(date, 'yyyyMMdd');
      },

      // 资金类型切换
      tabLi(nowIndex) {
        this.tabData.nowIndex = nowIndex;
        // console.log(nowIndex)`
        // 1:'支出资金', 2:'收入资金', 3:'冻结资金', 4:'解冻资金'
        this.searchForm.params.queryType = nowIndex + 1;

        this.getDataList()
      },
      // 获取表格数据
      async getDataList() {
        this.searchForm.params.minDateTime = this.min_accept_time
        this.searchForm.params.maxDateTime = this.max_accept_time
        const result = await getFundDetailListAPI(this.searchForm)
        try {
          this.tableData = result.data.records
          this.total = parseInt(result.data.total)
        } catch (e) {
          console.log(e)
        }
      },


      // 列表过滤查询
      handleSearch() {
        this.getDataList()
      },
      // 搜索重置（清空）
      handleReset() {
        // 初始化参数
        this.searchForm = this.$deepClone(searchConst)
        this.timeRange = ''
        this.getDataList()
      },
      // 列表每页条数变了
      handleSizeChange(val) {
        this.searchForm.size = val
        this.getDataList()
      },
      // 列表当前页码变了
      handleCurrentChange(val) {
        this.searchForm.current = val
        this.getDataList()
      },

    },
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  /* 文字顔色 */
  /* 浅绿 */
  .blackText {
    color: #4E4A46;
  }

  .greenText {
    color: #2DBAA5;
  }

  .lightGText {
    color: #76C819;
    font-size: 14px;
  }

  .orangeT {
    color: #FA6241;
  }

  .grayText {
    color: #7F7F7F;
  }

  .maRi4 {
    margin-right: 4px;
    // max-width: 200px;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
  }

  .fundManageDetail {
  }

  // 标题
  .fundManageDetail .titleBox {
    width: 100%;
    background: #ffffff;
    height: 44px;
    padding: 0 9px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
  }

  .titleBox b {
    color: #2B2727;
    font-size: 15px;
  }

  .titleBox span {
    color: #7F7F7F;
    font-size: 13px;
  }

  .titleBox .titRiImg {
    width: 76px;
    height: 24px;
  }


  // 标题
  .fundManageDetail .titleLine {
    width: 100%;
    height: 20px;
    margin-top: 12px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
  }

  .titleLine span {
    height: 20px;
    line-height: 20px;
    font-size: 15px;
    font-weight: bold;
    color: #2B2727;
  }

  .titleLine span::before {
    content: '';
    display: inline-block;
    width: 5px;
    height: 20px;
    margin-right: 6px;
    background: #FA6241;
    vertical-align: middle;
  }

  // 筛选框
  .fundManageDetail .searchBox {
    // height: 64px;
    margin-top: 12px;
    // background: #ffffff;
  }


  // tab切换-日期切换
  .fundManageDetail .tabBox {
    background: #fff;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }

  .tabBox li {
    float: left;
    width: 80px;
    color: #7F7F7F;
    font-size: 13px;
    cursor: pointer;
    position: relative;
  }

  .tabBox li.on {
    color: #F99A1A;
  }

  .tabBox li:after {
    content: '';
    position: absolute;
    // width: 80px;
    width: 60px;
    height: 3px;
    background: transparent;
    bottom: 9px;
    left: 0;
    left: 10px;
  }

  .tabBox li.on:after {
    background: #F99A1A;
  }


  // 表格
  .fundManageDetail .botTable {
    margin-top: 12px;
    width: 100%;
    background: #ffffff;
  }

  .botTable .tableTop {
    height: 54px;
    padding: 0 12px;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    border: 1px solid #EEEEEE;
    border-bottom: none;
  }

  .botTable .tableTop .top_le {
    font-size: 15px;
    font-weight: bold;
    color: #4E4A46;
  }

  .botTable .tableTop .exportBtn {
    width: 72px;
    height: 30px;
    line-height: 30px;
    font-size: 13px;
    border-radius: 4px;

    &:hover {
      background-color: rgb(247, 143, 120);
    }
  }

  .botTable .tableTop .exportBtn .exportIcon {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url('../../../assets/images/busy/Finance/FinancialAudit/CashOutAudit/exportBtn.png') no-repeat;
    background-size: 14px 14px;
  }

  /* 分页条 */
  .pageBox {
    width: 100%;
    padding: 15px 0 10px;
    display: flex;
    justify-content: flex-end;
    background: #ffffff;
    border: 1px solid #E4E4E4;
    border-top: none;
    //   border-bottom-left-radius: 3px;
    //   border-bottom-right-radius: 3px;
  }

  // 弹窗按钮-取消按钮
  .cancelBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 4px;
    background: #FFFFFF;
    color: #2B2727;
    color: #666666;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;

    &:hover {
      // background-color: #f1f1f1;
      border: 1px solid #d1d0d0;
    }
  }

  // 弹窗按钮-橙色按钮
  .refuseOBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    font-size: 14px;
    border-radius: 4px;
    background: #FA6241;
    color: #FFFFFF;

    &:hover {
      background-color: rgb(247, 143, 120);
    }
  }


</style>
